
const imgUrl = "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fseopic.699pic.com%2Fphoto%2F50079%2F1323.jpg_wh1200.jpg&refer=http%3A%2F%2Fseopic.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1659247127&t=b042f7d2b12955d415c7a86b7fa881b6"

const dataSource1 = () => {
    return {
        "auditTrainAddress": "",
        "auditTrainAge": "",
        "auditTrainCard": "",
        "auditTrainIntention": "",
        "auditTrainName": "",
        "auditTrainReason": "",
        "auditTrainRetireDate": "",
        "auditTrainState": 0,
        "auditTrainType": 0,
        "auditTrainUnit": "",
        "cardBack": "",
        "cardSquare": "",
        // "createDept": 0,
        // "createTime": "",
        // "createUser": 0,
        "houseCardHome": "",
        "houseCardMyself": "",
        // "id": 0,
        // "isDeleted": 0,
        // "releaseType": 0,
        "retireCard": "",
        "businessLicenseList": "", //营业执照（接口缺失字段）
        // "status": 0,
        // "tenantId": "",
        // "updateTime": "",
        // "updateUser": 0
    }
}



const formConfig = [
    {
        name: "auditTrainName",
        label: "姓名",
        require: true,
        // value: data?.auditTrainName
    },
    {
        name: "auditTrainCard",
        label: "身份证号码",
        require: true,
        pattern: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        // value: data?.auditTrainCard
    },
    {
        name: "auditTrainAge",
        label: "年龄",
        require: true,
        type: 'number',
        pattern: /^([0-9]|[1-5][0-9])$/,
        errorMsg: '不能超过法定退休年龄'
    },
    {
        name: "auditTrainRetireDate",
        label: "退役时间",
        require: true,
        type: "time",
        validator: (rule, value) => {
            let isTrue = new Date(value).valueOf() <=
                new Date('2011-11-01').valueOf()
            return !isTrue ? Promise.resolve() : value ? Promise.reject(new Error('2011年11月1日之前退役的不可申请')) : Promise.reject(new Error('请选择退役时间'))
        }
    },
    {
        name: "auditTrainAddress",
        label: "安置地",
        require: true,
        type: 'area',
        // value: data?.auditTrainAddress
    },
    {
        name: "auditTrainIntention",
        label: "培训意向",
        require: true,
        type: 'select',
        code: 'industry_code',
        mode: 'multiple',
        // value: data?.auditTrainIntention
    },
    {
        name: "phone",
        label: "联系电话",
        require: true,
        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
        // value: data?.auditTrainIntention
    },
];

const formConfig1 = [
    {
        name: "auditTrainName",
        label: "姓名",
        // value: data?.auditTrainName
    },
    {
        name: "auditTrainCard",
        label: "身份证号码",
        pattern: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        // value: data?.auditTrainCard
    },
    {
        name: "auditTrainAge",
        label: "年龄",
        type: 'number',
        pattern: /^([0-9]|[1-5][0-9])$/,
        errorMsg: '不能超过法定退休年龄'
    },
    {
        name: "auditTrainRetireDate",
        label: "退役时间",
        type: "time",
        validator: (rule, value) => {
            let isTrue = new Date(value).valueOf() <=
                new Date('2011-11-01').valueOf()
            return !isTrue ? Promise.resolve() : value ? Promise.reject(new Error('2011年11月1日之前退役的不可申请')) : Promise.reject(new Error('请选择退役时间'))
        }
    },
    {
        name: "auditTrainAddress",
        label: "安置地",
        type: 'area',
        // value: data?.auditTrainAddress
    },
    {
        name: "auditTrainUnit",
        label: "培训机构名称",
        // value: data?.auditTrainIntention
    },
    {
        name: "socialCreditCode",
        label: "统一社会信用代码",
        // value: data?.auditTrainIntention
    },
    {
        name: "phone",
        label: "联系电话",
        require: true,
        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
        // value: data?.auditTrainIntention
    },
];
export {
    dataSource1,
    formConfig,
    formConfig1
}
